// extracted by mini-css-extract-plugin
module.exports = {"root":"PortalModal_root__ZzN8n","overlay":"PortalModal_overlay__TyzYL"};